import React, { useContext, useMemo, useState } from "react";
import { printContext } from "../../../../../../../../core/contexts/printContext";
import CustomTable from "../../../../../../../../layout/components/customTable";
import { actionColumnFilterOptions } from "../../../../../../../../core/constants/actionColumnFilterOptions";
import { Button } from "antd";
import TagsModal from "../../../../../../../../layout/components/TagsMultiSelect/TagsModal";
const SystemCreatedtrackedItemTable = ({ data, actions, currentPage, pageSize, handleCustomTablePropChange = null, isPrintMode = false, paginationSection = null, }) => {
    const { nodeRef } = useContext(printContext);
    const [tagsModalOpen, setTagsModalOpen] = useState(false);
    const [modalTags, setModalTags] = useState([]);
    const [modalSearchValue, setModalSearchValue] = useState("");
    const transformedData = useMemo(() => {
        return data === null || data === void 0 ? void 0 : data.map((item) => {
            const tagsArray = item.tags || item.trackItems || [];
            const tagsText = tagsArray
                .map((tag) => (tag === null || tag === void 0 ? void 0 : tag.nameLower) || (tag === null || tag === void 0 ? void 0 : tag.name) || "")
                .join(" ")
                .trim();
            return Object.assign(Object.assign({}, item), { tagsSearchable: tagsText, tagsDisplay: tagsArray });
        });
    }, [data]);
    const columns = [
        {
            fieldName: "name",
            title: ["name"],
            sortable: true,
            defaultSortOrder: "ascend",
            width: 230,
            className: "bold-text",
            render: (text) => React.createElement("span", null, text),
        },
        {
            fieldName: "Level",
            title: ["TrackedItem.level"],
            width: 100,
            render: (text) => React.createElement("span", null, text),
        },
        {
            fieldName: "companyName",
            title: ["TrackedItem.relatedTo"],
            width: 200,
            render: (text) => React.createElement("span", null, text),
        },
        {
            fieldName: "tags",
            title: ["TrackedItem.tags"],
            width: 200,
            render: (_, trackedItem) => {
                const tags = trackedItem.tagsDisplay || trackedItem.tags || trackedItem.trackItems || [];
                if (!tags || tags.length === 0) {
                    return React.createElement("div", null, "-");
                }
                const visible = tags.slice(0, 3);
                const hasMore = tags.length > 3;
                return (React.createElement("div", { style: {
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "4px",
                        alignItems: "center",
                    } },
                    visible.map((tag) => (React.createElement("span", { key: tag.id || tag.name, style: {
                            background: "#f0f0f0",
                            padding: "2px 8px",
                            borderRadius: "4px",
                            fontSize: "12px",
                        } },
                        React.createElement("span", null, tag.nameLower || tag.name)))),
                    hasMore && (React.createElement(Button, { type: "link", size: "small", onClick: (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setModalTags(tags);
                            setTagsModalOpen(true);
                        }, style: { padding: 0 } }, "... more"))));
            },
        },
    ];
    const filteredTags = useMemo(() => {
        if (!modalSearchValue)
            return modalTags;
        const searchLower = modalSearchValue.toLowerCase();
        return modalTags.filter((tag) => (tag.nameLower || tag.name || "").toLowerCase().includes(searchLower));
    }, [modalTags, modalSearchValue]);
    const actionColumn = {
        fieldName: "actions",
        title: ["actions"],
        filterInfo: {
            //disabled is true in current data source DTO
            listing: actionColumnFilterOptions.map(({ text, value }) => ({
                text,
                value: !value,
            })),
            nestedKey: "disabled",
        },
        render: actions,
        width: 130,
    };
    const displayedColumns = actions ? [...columns, actionColumn] : columns;
    return (React.createElement("div", { className: "customListing", "data-test": "tracked-item-listing-table", ref: nodeRef },
        React.createElement(CustomTable, { data: transformedData, columns: displayedColumns, dataType: "any", currentPage: currentPage, pageSize: pageSize, totalCount: paginationSection === null || paginationSection === void 0 ? void 0 : paginationSection.totalRecords, itemEnableKey: "disabled", scroll: false, clientPagination: !isPrintMode, customTablePropChange: handleCustomTablePropChange, paginationSection: paginationSection, 
            // enableClientSearch={false}
            serverSearching: true }),
        React.createElement(TagsModal, { open: tagsModalOpen, onClose: () => {
                setTagsModalOpen(false);
                setModalSearchValue("");
            }, tags: modalTags, searchValue: modalSearchValue, onSearchChange: (val) => setModalSearchValue(val), filteredTags: filteredTags, onRemoveTag: () => { }, isTagCloseable: false })));
};
export default SystemCreatedtrackedItemTable;
